/* Show 'draft' or 'published' */
import { Box, BoxProps } from "@chakra-ui/react";
import { useContext } from "react";

import { TenantContext } from "@nens/ranalib";

import { getIsDraftVersion, getIsPublishedVersion } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";

export function DraftOrPublishedLabel(props: BoxProps) {
  const { isPublic } = useContext(TenantContext);
  const isPublished = usePublicationStore(getIsPublishedVersion);
  const isDraft = usePublicationStore(getIsDraftVersion);

  if (isPublic) return null; // Public is always published, so no need for this label

  if (isPublished) {
    return (
      <Box
        bgColor="semantic.success.background"
        borderColor="semantic.success.main"
        borderRadius="full"
        borderWidth="base"
        px={4}
        fontSize="sm"
        {...props}
      >
        Published
      </Box>
    );
  }

  if (isDraft) {
    return (
      <Box
        bgColor="semantic.warning.background"
        borderColor="semantic.warning.main"
        borderWidth="base"
        borderRadius="full"
        px={4}
        fontSize="sm"
        {...props}
      >
        Draft
      </Box>
    );
  }

  return null;
}
